import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required
} from 'vue-mc/validation';
export class Tip extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            tip_percentage: 0,
            user_type: 0
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            user_type: Number,
            tip_percentage: Number
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            tip_percentage: integer.and(required),
            user_type: integer.and(required),
        };
    }

    public routes() {
        return {
            fetch: "tips/{id}",
            save: "tips",
            delete: "tips/{id}"
        };
    }
}

export class TipCollection extends Collection {
    public model() {
        return Tip;
    }

    public defaults() {
        return {
            orderBy: 'id',
        };
    }

    public routes() {
        return {
            fetch: "tips",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}
